<script>
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import {sTema, sTituloPaginaAtual, sVidaUtilToken} from '../stores';
	import { dadosUsuarioLS, parseJWT } from '../utils';

	let tema = "dia";
	let anoBase = "";
	let dadosUsuarioP;
	let dadosUsuario = dadosUsuarioLS();
	let exibindoBotoes = false;
	let menuElemento;
	
	onMount(async () => {
		let tokenUsuarioParse = parseJWT(sessionStorage.getItem('AVAL_TOKEN'));
		let timeStampAtualEmSegundos = Math.round(Date.now() / 1000);

		if(!localStorage.getItem('AVAL_CONFIG_APP_TEMA'))
			localStorage.setItem('AVAL_CONFIG_APP_TEMA', tema);

		tema = localStorage.getItem('AVAL_CONFIG_APP_TEMA');
		anoBase = localStorage.getItem('AVAL_CONFIG_APP_ANOBASE');

		sTema.update(novoTema => tema);
		sVidaUtilToken.update(() => tokenUsuarioParse.exp);

		if (dadosUsuario)
			dadosUsuarioP.innerHTML = `<span id="ledVidaToken" title="Saúde do token de acesso">&#11044;</span> <strong>${dadosUsuario.email}</strong> / <span title="Ano Base" class="has-text-link-dark">AB: ${anoBase}</span> / Perfil: ${dadosUsuario.perfil_tostring}`;

		menuElemento = document.getElementById("menu");

		let elementoLed = document.getElementById('ledVidaToken');

		// verifica se expiração do token está abaixo de 1 hora
		if ($sVidaUtilToken - timeStampAtualEmSegundos < 3600) {
			elementoLed.style.color = "#a00";

			elementoLed.animate([
				{ opacity: 0.1 },
				{ opacity: 1 },
				{ opacity: 0.1 },
			], {
				duration:500,
				iterations:Infinity
			});
		}

		else {
			elementoLed.style.color = "#0a0";

			elementoLed.animate([
				{ opacity: 0.3 },
				{ opacity: 1 },
				{ opacity: 0.3 }
			], {
				duration:2000,
				iterations:Infinity
			});
		}
	});

	const trocarTema = () => {
		if (localStorage.getItem('AVAL_CONFIG_APP_TEMA') == "dia") tema = "noite";
		else tema = "dia"
		
		sTema.update(novoTema => tema);
		localStorage.setItem('AVAL_CONFIG_APP_TEMA', tema);
	}

	const sair = () => {
		push(`/limpeza-aplicacao/${Math.random()}?m=${window.btoa(unescape(encodeURIComponent("Saindo, aguarde ...")))}`);
	}

	const abrirOuFecharMenu = () => {
		if (exibindoBotoes) {
			exibindoBotoes = false;
			menuElemento.classList.remove('exibe-botoes');
			menuElemento.classList.add('esconde-botoes');
		} else {
			exibindoBotoes = true;
			menuElemento.classList.remove('esconde-botoes');
			menuElemento.classList.add('exibe-botoes');
		}
	}
</script>

<style>
	.barra-esquerda-1 {
		position: fixed;
		top: 10px;
		left: -10px;
		z-index: 10;
		background-color: #f5f5f5;
		border-radius: 8px;
		padding-left: 10px;
		border: 1px solid #ddd;
	}

	.barra-esquerda-2 {
		position: fixed;
		top: 44px;
		left: -10px;
		z-index: 10;
		background-color: #000;
		color: #fff !important;
		font-weight: bolder;
		border-radius: 8px;
		padding-left: 12px;
	}

	.menu-container {
		position: fixed;
		top: -10px;
		z-index: 10;
		cursor: pointer;
		right: 20px;
		
		border-radius: 8px;

		transition: all 0.2s cubic-bezier(.25, .8, .25, 1);
	}

	.esconde-botoes {
		top: -320px;
	}

	.exibe-botoes {
		top: -10px;
	}	

	.menu-item {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		height: 100px;
		width: 120px;
	}

	.menu-item-icone {
		height: 50px;		
	}

	.menu-item-texto {
		height: 50px;
	}
</style>

<div class="barra-esquerda-1">
	<p class="has-text-primary is-size-7 px-3 py-1" bind:this={dadosUsuarioP}></p>
</div>

<div class="barra-esquerda-2">
	<p class="is-size-6 px-3 py-1">{ $sTituloPaginaAtual }</p>
</div>

<div id="menu" class="menu-container esconde-botoes has-background-black">
	
	<div class="pt-4"></div>

	<a href="#/painel" class="menu-item">
		<div class="menu-item-icone">
			<span title="Voltar ao painel principal">
				<figure class="image is-24x24 pt-3">
					<img src="/painel.png" alt="ir para painel">
				</figure>
			</span>
		</div>
		<div class="menu-item-texto">
			<strong class="has-text-grey-lighter">PAINEL</strong>
		</div>
	</a>
	<span class="menu-item" on:click|preventDefault={trocarTema}>
		<div class="menu-item-icone">
			<span title="Trocar tema - claro / escuro">
				{#if tema == "dia"}
				<figure class="image is-24x24 pt-3">
					<img src="/sol.png" alt="trocar tema - dia">
				</figure>
				{:else}
				<figure class="image is-24x24 pt-3">
					<img src="/lua.png" alt="trocar tema - noite">
				</figure>
				{/if}
			</span>
		</div>
		<div class="menu-item-texto">
			<strong class="has-text-grey-lighter">TEMA</strong>
		</div>
	</span>
	<span class="menu-item" on:click|preventDefault={sair}>
		<div class="menu-item-icone">
			<span title="Sair (destruir token)">
				<figure class="image is-24x24 pt-3">
					<img src="/cadeado-fechado.png" alt="sair">
				</figure>
			</span>
		</div>
		<div class="menu-item-texto">
			<strong class="has-text-grey-lighter">SAIR</strong>
		</div>
	</span>
	
	<div class="menu-item" on:click={abrirOuFecharMenu}>
		<strong title="Clique ou toque para abrir/fechar" class="has-text-grey">
			MENU
		</strong>
	</div>
</div>